module.exports = __webpack_public_path__ + "DINNextLTPro-UltraLight.eot?85f7d1871f932d40b2051be762cafff6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-UltraLight.eot
// module id = 309
// module chunks = 0